module.exports = __webpack_public_path__ + "static/media/AB_iPhoneX_Facebook.fafbd6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_header/AB_iPhoneX_Facebook.png
// module id = 537
// module chunks = 0